import Rails from '@rails/ujs';
import { Controller } from 'stimulus';

export default class extends Controller {
  static targets = ['content', 'reload'];

  connect() {
    this._boundReloadContent = this._reloadContent.bind(this);
    document.addEventListener('promote:content-loader--reload', this._boundReloadContent);
  };

  disconnect() {
    document.removeEventListener('promote:content-loader--reload', this._boundReloadContent);
  };

  loadContent(event) {
    if (this._contentPreviouslyLoaded(this.contentTarget) || this._disabled(this.contentTarget)) {
      return;
    }

    this._loadData(this.contentTarget);
  };

  _reloadContent(event) {
    this.reloadTargets.forEach(target => {
      if (this._contentPreviouslyLoaded(target)) {
        if (this._hasPendingForms(target)) {
          target.dataset.contentLoaderLoaded = 'false';
          return;
        }

        this._loadData(target);
      }
    });
  };

  _hasPendingForms(target) {
    const contentId = target.dataset.contentId;
    if (!contentId) return false;

    const contentElement = document.getElementById(contentId);
    if (!contentElement) return false;

    const formControllers = this.application.controllers.filter(controller => {
      return controller.identifier === 'form-errors' &&
        contentElement.contains(controller.element);
    });

    return formControllers.some(controller => controller.anyPendingForms());
  };

  _loadData(element) {
    if (this.ajaxRequest) {
      this.ajaxRequest.abort(); // Abort previous ajax request.
    }

    Rails.ajax({
      url: this._url(element),
      type: 'GET',
      dataType: 'script',
      beforeSend: (xhr) => {
        this.ajaxRequest = xhr;
        return true;
      }
    });
  };

  _url(element) {
    return element.dataset.contentLoaderUrlValue;
  };

  _contentPreviouslyLoaded(element) {
    return element.dataset.contentLoaderLoaded === 'true';
  };

  _disabled(element) {
    return element.classList.contains('disabled')
  };
}
